module.exports = __webpack_public_path__ + "b8095b6aab30793aa11550599175b19d.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/14.png
// module id = 298
// module chunks = 0